<template>
  <div class="app-counter">
    <div class="app-counter__current">
      {{ current }}
    </div>
    <div class="app-counter__total">
      /{{ total }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCounter',
  props: {
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-counter {
    display: flex;
    color: #9F9F9F;
    font-family: 'Open Sans', 'sans-serif';
    font-weight: bold;
    font-size: 23px;
    align-items: flex-end;
    &__total {
      font-size: 18px;
    }
  }
</style>
